import type { Price, PriceInterval } from "schemas/agent-billing";

export const price = {
  getPerMonth(value: Price): { amount: number; currency: string } {
    return {
      amount: value.interval === "year" ? value.amount / 12 : value.amount,
      currency: value.currency,
    };
  },

  findByInterval({
    prices,
    interval,
  }: {
    prices: Price[];
    interval: PriceInterval;
  }): Price | undefined {
    return prices.find((price) => price.interval === interval);
  },

  findDefaultByInterval({
    prices,
    interval,
  }: {
    prices: Price[];
    interval: PriceInterval;
  }): Price | undefined {
    return (
      prices.find((price) => {
        return price.interval === interval && price.isDefault === true;
      }) ?? price.findByInterval({ prices, interval })
    );
  },
};
